<template>
  <SACModal
    modalClass="sh-action-modal"
    :cardClass="`sh-${actionModalView}`"
    :show="showActionModal"
    :close="() => toggleActionModal(false)"
  >
    <template
      v-if="actionModalView === 'csv-confirmation'"
      #content
    >
      <ExportCSVConfirmation />
    </template>
  </SACModal>
</template>

<script>
import systemHealthMixin from '@shared/mixins/systemHealthMixin';

import SACModal from '@shared/components/sac/SACModal.vue';
import ExportCSVConfirmation from './ExportCSVConfirmation.vue';

export default {
  name: 'ActionModal',
  components: {
    SACModal,
    ExportCSVConfirmation,
  },
  mixins: [systemHealthMixin],
};
</script>

<style lang="scss">

.sh-action-modal {
  .sh-contact {
    width: 1000px;
    height: 590px;
  }
  .ac-header-container {
    padding: 29px 24px 19px 24px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid $NBLUE10;
    .ac-header {
      font-size: 1.25rem;
      font-weight: 500;
    }
    .ac-close-button {
      width: 32px;
      height: 32px;
      border-radius: 6px;
      background-color: $NBLUE10;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        background-color: $NBLUE20;
      }
      .ac-close {
        width: 10px;
        height: 10px;
      }
    }
  }
  .ac-card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    animation: fadeIn 0.5s ease;
    .ac-body-container {
      flex: 1;
      padding: 31px 24px 26px 24px;
      overflow-y: auto;
      .ac-input-container {
        &:not(:last-child) {
          margin-bottom: 38px;
        }
        .ac-input-header {
          font-size: 1.25rem;
          font-weight: 500;
          margin-bottom: 11px;
          .ac-input-sub {
            font-size: 0.75rem;
            color: $N50;
          }
        }
        .ac-input-number {
          height: 48px;
          border-radius: 33px;
          width: 80px;
          padding: 0 20px;
          background-color: $NBLUE20;
        }
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        input {
          height: 48px;
          width: 100%;
          background-color: $NBLUE5;
          border: none;
          border-radius: 2px;
          padding: 0 10px;
        }
        textarea {
          width: 100%;
          height: 143px;
          padding: 8px 10px;
          border-radius: 2px;
          background-color: $NBLUE5;
          border: none;
          resize: none;
        }
        .ac-input-footer-container {
          display: flex;
          .ac-text-count {
            flex: 1;
            text-align: right;
            font-size: 0.75rem;
            font-weight: 500;
            color: $N60;
          }
        }
        .ac-input-error {
          color: $TOMATO100;
          font-size: 0.875rem;
        }
      }
      .ac-status {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background: $NBLUE5;
        padding: 20px;
        border-radius: 6px;
        font-size: 16px;
        margin-bottom: 8px;
        font-weight: 500;
      }
      .ac-note-container {
        margin-bottom: 10px;
        .ac-note {
          font-weight: 500;
        }
        .ac-action-note {
          font-weight: 200;
        }
        .ac-info {
          font-weight: 500;
        }
      }
      .ac-p-text {
        display: grid;
        justify-content: center;
      }
    }
    .ac-body-header {
      font-size: 18px;
      font-weight: 500;
      text-align: center;
    }
    .ac-body-button-container {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 24px;
      .ac-form-button {
        width: 120px;
        height: 40px;
        border-radius: 6px;
        background-color: $NBLUE10;
        font-weight: 600;
        &:hover {
          background-color: $NBLUE20;
        }
        &:not(:first-child) {
          margin-left: 11px;
          background-color: $NBLUE100;
          color: $WHITE;
          &:hover {
            background-color: $NBLUE90;
          }
        }
      }
    }
  }
  .ac-footer-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 16px 24px;
    border-top: 1px solid $NBLUE10;
    .ac-back-container {
      flex: 1;
      justify-content: flex-start;
      .ac-back-button {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 17px;
        width: 177px;
        height: 40px;
        border-radius: 6px;
        background-color: $NBLUE10;
        &:hover {
          background-color: $NBLUE20;
        }
        .back-icon {
          width: 6px;
        }
        .button-text {
          font-weight: 600;
        }
      }
    }
    .ac-form-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 120px;
      height: 40px;
      border-radius: 6px;
      background-color: $NBLUE10;
      font-weight: 600;
      &:hover {
        background-color: $NBLUE20;
      }
      &:not(:first-child) {
        margin-left: 11px;
        background-color: $NBLUE100;
        color: $WHITE;
        &:hover {
          background-color: $NBLUE90;
        }
      }
      .ac-processing {
        width: 30px;
      }
    }
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
